/**
 * @fileoverview User dropdown module (in the top nav).
 * @author dburke2@gannett.com (David Burke)
 */

define('modules/users/site-nav-salutation-module',[
    'jquery',
    'underscore',
    'modules/header/site-nav-dropdown',
    'pubsub',
    'utils',
    'user-manager',
    'state',
    'user-accounts/firefly-user-account',
    'modules/global/expired-card',
    'admanager'
],
function(
    $,
    _,
    SiteNavDropdown,
    PubSub,
    Utils,
    UserManager,
    StateManager,
    FireflyUserAccount,
    ExpiredCard,
    AdManager
) {
    'use strict';

    /**
     * View class.
     */
    var SalutationDropdown = SiteNavDropdown.extend({

        events: {
            'mouseenter': 'onMouseEnter',
            'mouseleave': 'onMouseLeave',
            'click .site-nav-dropdown': 'closeDropdown',
            'click .snsm-section .snsm-register': 'redirectToAccountCreation'
        },

        initialize: function(options) {
            this.pubSub = {
                'page:load': this.updateOnPageLoad,
                'user:statuschange': this.showLoggedInStatus
            };
            _.bindAll(this, 'redirectToAccountCreation');
            this.$siteNavDropdown = this.$('.snsm-dropdown');

            this.loginData = Utils.getNested(window.site_vars, 'userAuthentication', 'login');
            this.logoutData = Utils.getNested(window.site_vars, 'userAuthentication', 'logout');
            this.loginState = 'pending';
            this.canShowCCModal = false;

            AdManager.getActiveSlotStatistics().done(_.bind(function(info) {
                if (this.destroyed) {
                    return;
                }

                //ads finished being called, determine if high impact ad is present
                if (!info.high_impact && Utils.getNested(window.site_vars, 'flags', 'expired_credit_card_modal')) {
                    this.canShowCCModal = true;
                }
            }, this));

            SiteNavDropdown.prototype.initialize.call(this, options);
        },

        /**
         * Update all '.userAuth-redirect' marked a tag URLs on the page with the current page's redirect URL. Updated to account for other QSPs existing and use the configuration settings for userAuth.
         * @param {Event} e event
         */
        updateOnPageLoad: function(e) {
            // when cancelling, we go back to the current page
            var encodedPageURL = encodeURIComponent(window.location);
            // when succeeding, go back to the URL of the asset.  which might be the same but might not on the get-access page
            var encodedSuccessURL = encodeURIComponent(window.firefly_urls.onSuccessRedirectURL);
            var success_qsp =  this.loginData.success_qsp;
            var cancel_qsp = this.loginData.cancel_qsp;
            var logout_qsp = this.logoutData.return_qsp;
            var newQSP = '?' + success_qsp + '=' + encodedSuccessURL + '&' + cancel_qsp + '=' + encodedPageURL + '&' + logout_qsp + '=' + encodedSuccessURL ;

            $(".userAuth-redirect").each(function(index, link) {
                var append = "";
                var splitUrl;
                var qspList;
                var $link = $(link);
                var url = $link.attr('href');
                // this regex will match on query strings that start with the success or cancel qsp as defined by the site's config
                var hasSuccessCancelQSPs = new RegExp('^'+success_qsp+'|^'+cancel_qsp+'|^'+logout_qsp);

                if (_.isString(url)) {
                    // split the url into an array based on '?' and '&' characters
                    splitUrl = url.split(/[\?\&]/);
                    qspList = splitUrl.splice(1);

                    if (qspList.length > 0) {
                        qspList = _.filter(qspList, function(param){
                            if(!hasSuccessCancelQSPs.test(param)){
                                return param;
                            }
                        });
                        append = '&' + qspList.join('&');
                    }
                    $link.attr('href', splitUrl[0] + newQSP + append);
                }
            });

            //Separate redirect URL used specifically for the account activation/lookup static page
            $(".userActivate-redirect").each(function(index, link) {
                var $link = $(link);
                var url = $link.attr('href');

                //Append old QSPs to the end, if they exist
                var splitUrl = url.split(/[\?\&]/);
                var oldQSP = splitUrl.slice(1).join('&');
                newQSP = '?onSuccessRedirectURL=' + encodedSuccessURL;
                $link.attr('href', splitUrl[0] + newQSP + '&' + oldQSP);
            });
        },

        showLoggedInStatus: function(accountName, loginStatus, userData) {
            if (accountName !== 'firefly') {
                return;
            }

            if (loginStatus === 'loggedIn') {
                this.showLoggedInUser(userData);

                if (userData.hasMarketAccess) {
                    this.checkCreditCardStatus(userData);
                }

            } else if (loginStatus !== 'loggingIn') {
                this.showLoggedOutUser();
            }

            this.loginState = (loginStatus === 'loggedIn') ? 'registered' : 'notregistered';

            if (this.loginState === 'registered') {
                this.$('.snsm-link-view-account .snsm-link-text').html('Manage Account');
                this.$('.snsm-link-pay-bill .snsm-link-text').html('Pay Bill');

                var productTypes = Utils.getNested(userData, 'userInfo', 'response', 'insights', 'productType') || [];
                productTypes = productTypes.constructor === Array ? productTypes : [productTypes];
                productTypes = productTypes.map(function (val) {
                    return val.toLowerCase();
                });

                this.$('.snsm-wrap .snsm-links > li').each(_.bind(function (index, list) {
                    if (list.dataset.hoverdropdown){
                        var  states = list.dataset.hoverdropdown.split(' ');
                        var useFallbackState = productTypes.indexOf('digital basic') === -1 && productTypes.indexOf('digital premium') === -1 && productTypes.indexOf('print') === -1;

                        // If no values are assigned to productType fallback to print state behavior
                        if (userData.hasMarketAccess && useFallbackState ) {
                            states.push('print');
                        }
                        if (!this._checkIfLinkShouldDisplay(states, userData, productTypes, useFallbackState)) {
                            list.style.display = "none";
                        }
                    }
                }, this));
            }

            // Add data-track-label to links in salutation dropdown
            this.setSalutationLinkDataTrackLabel('snsm-link-view-account');
            this.setSalutationLinkDataTrackLabel('snsm-link-eedition');
            this.setSalutationLinkDataTrackLabel('snsm-link-newsletters');
            this.setSalutationLinkDataTrackLabel('snsm-link-pay-bill');
            this.setSalutationLinkDataTrackLabel('snsm-link-delivery-issues');
            this.setSalutationLinkDataTrackLabel('snsm-link-stop-restart');
            this.setSalutationLinkDataTrackLabel('snsm-link-member-guide');
            this.setSalutationLinkDataTrackLabel('snsm-link-help');
            this.setSalutationLinkDataTrackLabel('snsm-link-sign-out');
            this.setSalutationLinkDataTrackLabel('snsm-link-sign-in');
            this.setSalutationLinkDataTrackLabel('snsm-link-activate');
            this.setSalutationLinkDataTrackLabel('snsm-register');
        },

        setSalutationLinkDataTrackLabel: function(className) {
            var el = this.$('.' + className);
            var linkText = el.find('.snsm-link-text').html() || el.text();
            el.attr('data-track-label', 'site-nav-salutation-module|' + this.loginState + '|click|' + linkText);
        },

        /**
         * Checks to see if the user's credit card has expired, will expire soon, or was rejected on their last payment
         */
        checkCreditCardStatus: function(user) {
            if(!user) {
                return false;
            }

            //if 72 hours haven't passed since the last check, halt
            var date = new Date();
            if(date.getTime() < parseInt(localStorage.getItem('expired-credit-card')) + 259200000) {
                return false;
            }

            this._verifyExpiredLicense(user.licensePaymentHistory[0]);
        },

        _verifyExpiredLicense: function(paymentInfo) {
            if(paymentInfo) {
                var date = new Date(),
                    licenseId = paymentInfo.licenseId;

                if(paymentInfo.lastPaymentFailed) {
                    this._setupExpiredCardSubview(licenseId, true);
                }

                //date.getMonth() returns the month number starting at 0 (i.e. January = 0, February = 1, etc.) so we always have to add 1 to get the current month
                if(paymentInfo.ccExpirationYear) {
                    var expirationYear = parseInt(paymentInfo.ccExpirationYear, 10);
                    //User's card expired last year
                    if(date.getFullYear() > expirationYear) {
                        this._setupExpiredCardSubview(licenseId, true);
                    } else if(date.getFullYear() === expirationYear) {
                        if(paymentInfo.ccExpirationMonth) {
                            var expirationMonth = parseInt(paymentInfo.ccExpirationMonth, 10);
                            if(date.getMonth() + 1 === expirationMonth) {
                                //User's card expires this month
                                this._setupExpiredCardSubview(licenseId, false);
                            } else if(date.getMonth() + 1 > expirationMonth) {
                                //User's card has already expired
                                this._setupExpiredCardSubview(licenseId, true);
                            }
                        }
                    }
                }
            }
        },

        _setupExpiredCardSubview: function(accountNumber, isExpired) {
            this.subviews.expiredcard = new ExpiredCard({
                licenseId: accountNumber,
                isExpiredNow: isExpired
            });
        },

        /**
         * Shows the user header nav item in the logged out state.
         */
        showLoggedOutUser: function() {
            this.$siteNavDropdown.removeClass('authenticated subscribed');
        },

        /**
         * Shows the user header nav item in the logged in state.
         */
        showLoggedInUser: function(userInfo) {
            var userAccount = UserManager.getAccount('firefly');
            this.$siteNavDropdown.addClass('authenticated');
            this.$('.snsm-link-sign-out').removeClass('hidden');
            if (userInfo.hasMarketAccess) {
                this.$siteNavDropdown.addClass('subscribed');

                if (Utils.getNested(window.tp, 'offer')) {
                    window.tp.offer.close();
                }
            }
        },

        destroy: function() {
            SiteNavDropdown.prototype.destroy.call(this);
        },

        _checkIfLinkShouldDisplay: function (types, userData, productTypes, useFallbackState) {
            if (types.indexOf('no-paywall') > -1 && userData.hasMarketAccess) {
                return true;
            }
            for (var i=0; i < types.length; i++) {
                if (types[i] === "e-edition" && productTypes.indexOf('digital premium') > -1) {
                    return true;
                } else  if( types[i] === "digital" && productTypes.indexOf('digital basic') > -1) {
                    return true;
                } else if (types[i] === "!print" && types.indexOf('print') === -1 && productTypes.indexOf('print') === -1) {
                    return true;
                } else if (types[i] === "print" && (productTypes.indexOf('print') > -1 || (userData.hasMarketAccess && useFallbackState))) {
                    return true;
                }
            }
            return false;
        },

        /**
         * Hack to prevent IE from encoding &reg to ®
         */
        redirectToAccountCreation: function(e) {
            e.preventDefault();
            var anchor = event.target.closest("a");
            window.location.href = anchor.getAttribute('href') + '/authenticate?requested-state=create-account&amp;reg_source=CPNAVBAR&amp;reg_medium=ONSITE&amp;reg_campaign=signin&amp;reg_delivery=ux';
        }
    });

    return SalutationDropdown;

});

